import { DaVinciTransport } from '@ofs-vuex-crud';
import config from '@/config';

const providerInstance = new DaVinciTransport({ apiBase: config.apiBase });

export default providerInstance;
